import _classCallCheck from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "/var/www/primes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { MODE_SSR, EventType } from 'overmind';
import { // @ts-ignore
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Component, createElement, // @ts-ignore
useEffect, // @ts-ignore
useState, useRef, useLayoutEffect, createContext, useContext } from 'react';
var IS_PRODUCTION = process.env.NODE_ENV === 'production';
var context = createContext({});
var nextComponentId = 0;
export var Provider = context.Provider;
export var createHook = function createHook(overmindInstance) {
  var currentComponentInstanceId = 0;
  var ReactCurrentOwner = __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;

  var useCurrentComponent = function useCurrentComponent() {
    return ReactCurrentOwner && ReactCurrentOwner.current && ReactCurrentOwner.current.elementType ? ReactCurrentOwner.current.elementType : {};
  };

  var useForceRerender = function useForceRerender() {
    var _useState = useState(function () {
      return true;
    }),
        _useState2 = _slicedToArray(_useState, 2),
        setState = _useState2[1];

    var forceRerender = function forceRerender(_, __, flushId) {
      setState(flushId);
    };

    return forceRerender;
  };

  return function () {
    var overmind = overmindInstance || useContext(context);

    if (overmind.mode.mode === MODE_SSR) {
      return {
        state: overmind.state,
        actions: overmind.actions,
        effects: overmind.effects,
        addMutationListener: overmind.addMutationListener
      };
    }

    var component = useCurrentComponent();
    var name = component.name;
    component.__componentId = typeof component.__componentId === 'undefined' ? nextComponentId++ : component.__componentId;

    var _useRef = useRef(overmind.proxyStateTree.getTrackStateTree()),
        tree = _useRef.current;

    if (IS_PRODUCTION) {
      var rerenderComponent = useForceRerender();
      tree.track(rerenderComponent);
      useEffect(function () {
        return function () {
          ;
          overmind.proxyStateTree.disposeTree(tree);
        };
      }, []);
      useLayoutEffect(function () {
        return tree.stopTracking();
      });
    } else {
      var _useRef2 = useRef(currentComponentInstanceId++),
          componentInstanceId = _useRef2.current;

      var _rerenderComponent = useForceRerender();

      tree.track(function (_, __, flushId) {
        _rerenderComponent(_, __, flushId);

        overmind.eventHub.emitAsync(EventType.COMPONENT_UPDATE, {
          componentId: component.__componentId,
          componentInstanceId: componentInstanceId,
          name: name,
          flushId: flushId,
          paths: Array.from(tree.pathDependencies)
        });
      });
      useLayoutEffect(function () {
        return tree.stopTracking();
      });
      useEffect(function () {
        overmind.eventHub.emitAsync(EventType.COMPONENT_ADD, {
          componentId: component.__componentId,
          componentInstanceId: componentInstanceId,
          name: name,
          paths: Array.from(tree.pathDependencies)
        });
        return function () {
          ;
          overmind.proxyStateTree.disposeTree(tree);
          overmind.eventHub.emitAsync(EventType.COMPONENT_REMOVE, {
            componentId: component.__componentId,
            componentInstanceId: componentInstanceId,
            name: name
          });
        };
      }, []);
    }

    return {
      state: tree.state,
      actions: overmind.actions,
      effects: overmind.effects,
      addMutationListener: overmind.addMutationListener
    };
  };
};
export var createConnect = function createConnect(overmindInstance) {
  return function (component) {
    var componentInstanceId = 0;
    var name = component.name;
    var populatedComponent = component;
    populatedComponent.__componentId = typeof populatedComponent.__componentId === 'undefined' ? nextComponentId++ : populatedComponent.__componentId;
    var isClassComponent = component.prototype && typeof component.prototype.render === 'function';

    if (isClassComponent) {
      var originalRender = component.prototype.render;

      component.prototype.render = function () {
        var _this = this;

        if (this.props.overmind) {
          return this.props.overmind.tree.trackScope(function () {
            return originalRender.call(_this);
          }, this.props.overmind.onUpdate);
        }

        return originalRender.call(this);
      };
    }

    if (IS_PRODUCTION) {
      var HOC =
      /*#__PURE__*/
      function (_Component) {
        _inherits(HOC, _Component);

        function HOC(props, context) {
          var _this2;

          _classCallCheck(this, HOC);

          _this2 = _possibleConstructorReturn(this, _getPrototypeOf(HOC).call(this, props));

          _this2.onUpdate = function () {
            _this2.setState({
              overmind: {
                state: _this2.tree.state,
                effects: _this2.overmind.effects,
                actions: _this2.overmind.actions,
                addMutationListener: _this2.overmind.addMutationListener,
                onUpdate: _this2.onUpdate,
                tree: _this2.tree
              }
            });
          };

          _this2.overmind = overmindInstance || context;
          _this2.tree = _this2.overmind.proxyStateTree.getTrackStateTree();
          _this2.state = {
            overmind: {
              state: _this2.tree.state,
              effects: _this2.overmind.effects,
              actions: _this2.overmind.actions,
              addMutationListener: _this2.overmind.addMutationListener,
              onUpdate: _this2.onUpdate,
              tree: _this2.tree
            }
          };
          return _this2;
        }

        _createClass(HOC, [{
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.overmind.proxyStateTree.disposeTree(this.tree);
          }
        }, {
          key: "render",
          value: function render() {
            var _this3 = this;

            if (isClassComponent) {
              return createElement(component, Object.assign({}, this.props, {
                overmind: this.state.overmind
              }));
            }

            return createElement(function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return _this3.tree.trackScope(function () {
                return component.apply(void 0, args);
              }, _this3.onUpdate);
            }, Object.assign({}, this.props, {
              overmind: this.state.overmind
            }));
          }
        }]);

        return HOC;
      }(Component);

      HOC.contextType = context;
      return HOC;
    } else {
      var _HOC =
      /*#__PURE__*/
      function (_Component2) {
        _inherits(_HOC, _Component2);

        function _HOC(props, context) {
          var _this4;

          _classCallCheck(this, _HOC);

          _this4 = _possibleConstructorReturn(this, _getPrototypeOf(_HOC).call(this, props));
          _this4.componentInstanceId = componentInstanceId++;
          _this4.currentFlushId = 0;

          _this4.onUpdate = function (mutatons, paths, flushId) {
            _this4.currentFlushId = flushId;
            _this4.isUpdating = true;

            _this4.setState({
              overmind: {
                state: _this4.tree.state,
                effects: _this4.overmind.effects,
                actions: _this4.overmind.actions,
                addMutationListener: _this4.overmind.addMutationListener,
                onUpdate: _this4.onUpdate,
                tree: _this4.tree
              }
            });
          };

          _this4.overmind = overmindInstance || context;
          _this4.tree = _this4.overmind.proxyStateTree.getTrackStateTree();
          _this4.state = {
            overmind: {
              state: _this4.tree.state,
              effects: _this4.overmind.effects,
              actions: _this4.overmind.actions,
              addMutationListener: _this4.overmind.addMutationListener,
              onUpdate: _this4.onUpdate,
              tree: _this4.tree
            }
          };
          return _this4;
        }

        _createClass(_HOC, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.overmind.eventHub.emitAsync(EventType.COMPONENT_ADD, {
              componentId: populatedComponent.__componentId,
              componentInstanceId: this.componentInstanceId,
              name: name,
              paths: Array.from(this.tree.pathDependencies)
            });
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            if (this.isUpdating) {
              this.overmind.eventHub.emitAsync(EventType.COMPONENT_UPDATE, {
                componentId: populatedComponent.__componentId,
                componentInstanceId: this.componentInstanceId,
                name: name,
                flushId: this.currentFlushId,
                paths: Array.from(this.tree.pathDependencies)
              });
              this.isUpdating = false;
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.overmind.proxyStateTree.disposeTree(this.tree);
            this.overmind.eventHub.emitAsync(EventType.COMPONENT_REMOVE, {
              componentId: populatedComponent.__componentId,
              componentInstanceId: this.componentInstanceId,
              name: name
            });
          }
        }, {
          key: "render",
          value: function render() {
            var _this5 = this;

            if (isClassComponent) {
              return createElement(component, Object.assign({}, this.props, {
                overmind: this.state.overmind
              }));
            }

            return createElement(function () {
              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              return _this5.tree.trackScope(function () {
                return component.apply(void 0, args);
              }, _this5.onUpdate);
            }, Object.assign({}, this.props, {
              overmind: this.state.overmind
            }));
          }
        }]);

        return _HOC;
      }(Component);

      _HOC.contextType = context;
      Object.defineProperties(_HOC, {
        name: {
          value: 'Connect' + (component.displayName || component.name || '')
        }
      });
      return _HOC;
    }
  };
};